module.exports = __webpack_public_path__ + "img/play_color.aaef9777.svg";